import request from './utils/request';

/**
 * 获取 社会组织机构类型 字典数据
 * @returns {Promise} 返回请求结果Promise对象
 */
export function getSocialOrganizationsTypesList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: {
      type: 'social_organizations_types'
    }
  });
}


export function getIndustryTypesList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: {
      type: 'industry_type'
    }
  });
}

/**
 * （调解员）擅长纠纷类型字典，与后台 dict type dispute_type 一致
 */
export function getDisputeTypeList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: {
      type: 'dispute_type'
    }
  });
}


/**
 * 获取专家业务-行业类型字典数据
 * @returns 专家业务-行业类型字典数据
 */
export function getExpertIndustryTypesList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: {
      type: 'expert_industry_type'
    }
  });
}


/**
 * 获取专家业务-专业背景字典数据
 * @returns 专家业务-专业背景字典数据
 */
export function getSpecialtyTypeList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: {
      type: 'specialty_type'
    }
  });
}

/**
 * 获取专家业务-核心职能/擅长事务字典数据
 * @returns 专家业务-核心职能/擅长事务字典数据
 */
export function getCoreSkillsTypeList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: {
      type: 'core_skills_type'
    }
  });
}

/**
 * 获取咨询专家业务-擅长事务类型字典数据
 * @returns 咨询专家业务-擅长事务类型字典数据
 */
export function getConsultMatterTypeList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: {
      type: 'consult_matter_type'
    }
  });
}

/**
 * 获取咨询专家业务-涉及地区字典数据
 * @returns 咨询专家业务-涉及地区字典数据
 */
export function getServiceRegionsTypeList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: {
      type: 'service_regions_type'
    }
  });
}

/**
 * 合同模板-合同类型（与后台字典类型 cnt_type 一致）
 */
export function getCntTypeList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: {
      type: 'cnt_type'
    }
  });
}

/**
 * 合同模板-合同行业类型（与后台字典类型 cnt_industry_type 一致）
 */
export function getCntIndustryTypeList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: {
      type: 'cnt_industry_type'
    }
  });
}


// 获取17中作品类型
export function getWorksTypeList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: { type: 'classification_original_works' }
  })
}

/**
 * 治理子渠道-身份类型（与后台字典类型 governance_channel_identity_type 一致）
 */
export function getGovernanceChannelIdentityTypeList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: { type: 'governance_channel_identity_type' }
  })
}

/**
 * 区级渠道地区类型（与后台字典类型 channel_district_type 一致）
 */
export function getChannelDistrictTypeList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: { type: 'channel_district_type' }
  })
}

/**
 * 版权产业渠道-身份类型（与后台字典类型 industry_channel_identity_type 一致）
 */
export function getIndustryChannelIdentityTypeList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: { type: 'industry_channel_identity_type' }
  })
}

/**
 * 全球前沿报告分类（与后台字典类型 global_report_report_type 一致）
 */
export function getGlobalReportReportTypeList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: { type: 'global_report_report_type' }
  })
}

/** 授权交易-IP类型（后台字典类型：ip_type） */
export function getTransactionIpTypeList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: { type: 'ip_type' }
  })
}

/** 授权交易-IP诞生地（后台字典类型：ip_address） */
export function getTransactionIpBirthplaceList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: { type: 'ip_address' }
  })
}

/** 授权交易-IP擅长类别（后台字典类型：ip_specialty） */
export function getTransactionIpSpecialtyList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: { type: 'ip_specialty' }
  })
}

/** 授权交易-IP通俗类型（后台字典类型：ip_popular_type） */
export function getTransactionIpPopularTypeList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: { type: 'ip_popular_type' }
  })
}

/** 授权交易-IP可授权地区（后台字典类型：ip_auth_region，多选） */
export function getTransactionIpAuthRegionList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: { type: 'ip_auth_region' }
  })
}

/** 授权交易-IP已收录授权案例涉及行业（后台字典类型：ip_case_industry，多选） */
export function getTransactionIpCaseIndustryList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: { type: 'ip_case_industry' }
  })
}

/** 授权交易-衍生案例授权品类（后台字典类型：case_type） */
export function getTransactionIpCaseCategoryList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: { type: 'case_type' }
  })
}

/** 授权交易-衍生案例授权方式（后台字典类型：case_auth_type） */
export function getTransactionIpCaseAuthTypeList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: { type: 'case_auth_type' }
  })
}

/** 授权交易-品牌类型（后台字典类型：brand_type） */
export function getTransactionBrandTypeList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: { type: 'brand_type' }
  })
}

/** 授权交易-品牌行业（后台字典类型：brand_industry） */
export function getTransactionBrandIndustryList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: { type: 'brand_industry' }
  })
}

/** 授权交易-品牌大类（后台字典类型：brand_category） */
export function getTransactionBrandCategoryList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: { type: 'brand_category' }
  })
}

/** 授权交易-供应链类型（后台字典类型：supply_type） */
export function getTransactionSupplyTypeList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: { type: 'supply_type' }
  })
}

/** 授权交易-供应链优势品类（后台字典类型：supply_product） */
export function getTransactionSupplyProductList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: { type: 'supply_product' }
  })
}

/** 授权交易-供应链行业大类（后台字典类型：supply_industry） */
export function getTransactionSupplyIndustryList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: { type: 'supply_industry' }
  })
}

/** 授权交易-供应链产业带（后台字典类型：supply_residence） */
export function getTransactionSupplyResidenceList() {
  return request({
    url: '/web/dict/getDictByType',
    method: 'get',
    params: { type: 'supply_residence' }
  })
}

